import React from 'react';
import Navbar from './global-components/navbar';

import NATADetails from './section-components/nata-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";
import Page_header from './global-components/page-headernata';

const NATA = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Best NATA Coaching in Chennai | MIET Education, Kodambakkam</title>
            <meta name="description" content="MIET Education in Kodambakkam, Chennai, offers best  NATA coaching with expert faculty, comprehensive study materials, and a proven success record in architecture exams." />
        </Helmet>
        <Page_header headertitle="NATA" />
        <NATADetails />
        <Footer />
    </div>
}

export default NATA